<template>
  <div>
    <table class="table is-fullwidth is-size-7">
      <tr>
        <th colspan="5">{{"hdraces bets.ticket" | translate}}</th>
        <th>{{"hdraces bets.profit" | translate}}</th>
      </tr>
      <template v-for="(ticket, i) in tickets">
        <tr :class="{'hdraces-tickets-even':i%2==0}">
          <td colspan="4">
            <router-link v-if="showUser" :to="{ name: 'player', params: { playerId: ticket.userId } }">{{ticket.username}}</router-link>
            <span class="has-text-weight-bold">#{{ticket.hdRacesTicketId}}</span>
          </td>
          <td>
            <span v-if="ticket.status=='win'" class="has-text-danger has-text-weight-bold">{{"hdraces bets.status.win" | translate}} {{ticket.ticketWin | currency(ticket.currency)}}</span>
            <span v-if="ticket.status=='loss'" class="has-text-link has-text-weight-bold">{{"hdraces bets.status.loss" | translate}} {{ticket.ticketStake | currency(ticket.currency)}}</span>
          </td>
          <td class="has-text-weight-bold" :class="{'has-text-danger':ticket.ticketWin > ticket.ticketStake, 'has-text-success':ticket.ticketWin < ticket.ticketStake}">
            {{ticket.ticketStake - ticket.ticketWin | currency(ticket.currency)}}
          </td>
        </tr>
        <tr :class="{'hdraces-tickets-even':i%2==0}" v-for="jp in (ticket.jackpots || [])" v-if="jp.status == 'win'">
          <td colspan="4">
            <router-link v-if="showUser" :to="{ name: 'player', params: { playerId: ticket.userId } }">{{ticket.username}}</router-link>
            <span class="has-text-weight-bold">#{{ticket.hdRacesTicketId}}</span>
          </td>
          <td>
            <span class="has-text-danger has-text-weight-bold">{{"hdraces bets.win" | translate}} {{jp.win | currency(ticket.currency)}}</span>
          </td>
          <td class="has-text-weight-bold has-text-danger">
            {{ticket.ticketStake - jp.win | currency(ticket.currency)}}
          </td>
        </tr>
        <template v-for="bet in ticket.bets">
          <tr :class="{'hdraces-tickets-even':i%2==0}">
            <td class="has-text-weight-bold">
              {{ticket.created | datetime}}
              <span v-if="bet.odds.length==1">{{"hdraces bets.single" | translate}}</span>
              <span v-if="bet.odds.length>1">{{"hdraces bets.express" | translate}} {{bet.odds.length}}</span>
            </td>
            <td>{{"hdraces bets.bet" | translate}} <span class="has-text-weight-bold">{{bet.stake | currency(ticket.currency)}}</span></td>
            <td colspan="2">@{{bet.rate | rate}}</td>
            <td>
              <span v-if="bet.status=='win'" class="has-text-danger">{{"hdraces bets.status.win" | translate}} {{bet.win | currency(ticket.currency)}}</span>
              <span v-if="bet.status=='loss'" class="has-text-link">{{"hdraces bets.status.loss" | translate}} {{bet.stake | currency(ticket.currency)}}</span>
            </td>
            <td></td>
          </tr>
          <tr v-for="odd in bet.odds" :class="{'hdraces-tickets-even':i%2==0}">
            <td>{{odd.feedId}} #{{odd.eventId}}</td>
            <td>
              <template v-if="getOddPlayers(odd.oddKey).length">
                {{"hdraces bets.player" | translate}}
                {{getOddPlayers(odd.oddKey).join(', ')}},
                {{odd.market}}
              </template>
              <template v-else>
                {{odd.oddKey}}
              </template>
            </td>
            <td>@{{odd.rate | rate}}</td>
            <td>
              {{"hdraces bets.result" | translate}}
              <template v-if="odd.eventResult && odd.eventResult.length">
                [{{odd.eventResult.join(', ')}}]
              </template>
              <template v-else>
                -
              </template>
            </td>
            <td :class="{'has-text-danger': bet.status=='win', 'has-text-link': bet.status=='loss'}">
              {{`hdraces bets.odd status.${odd.status}` | translate}}
            </td>
            <td></td>
          </tr>
        </template>
      </template>
    </table>

    <pagination @change="loadTickets();" ref="pagination" :page-size="10" />
  </div>
</template>

<script>
  import pagination from './pagination.vue'

  export default {
    name: 'hdraces-tickets-list',
    components: { pagination },
    props: {
      dataFunc: {
        type: Function,
        required: true
      },
      showUser: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        tickets: []
      }
    },
    async mounted() {
      await this.loadTickets();
    },
    methods: {
      async loadTickets() {
        const filter = {
          pageNumber: this.$refs.pagination.pageNumber,
          pageSize: this.$refs.pagination.pageSize
        };
        const data = await this.dataFunc(filter);
        this.tickets = data.items;
        this.$refs.pagination.set(data.pageNumber, data.totalPages);
      },
      getOddPlayers(oddId) {
        return Array.from(oddId.replace(/\D+/g, '')).map(p => parseInt(p));
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/common/hdraces-tickets-list.vue